export default __webpack_public_path__ + "static/fillter_icon.png";